import Vue from 'vue'

export const newspaperMaterials = {
    state: {
        newspaperMaterials: [],
        status: 'idle',
        sortOptions: [
            {
                query: 'public_from',
                label: 'Data obowiązywania'
            }
        ],
        sort: {
            by: 'public_from',
            direction: 'desc'
        },
        filters: {
            name: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['nazwie pliku']
            },
            locationId: {
                type: 'checkboxes',
                value: [],
                getter: 'getMerchantsFormats',
                text: 'Sklepy',
                firstOption: 'Wszystkie',
                expectedType: 'string',
                disabledLinkGenerator: true
            },
            filename: {
                additionalText: 'Nazwa pliku',
                type: 'search-input',
                value: '',
                text: 'Nazwa pliku',
                noRefetch: true
            },
            category: {
                additionalText: 'Kategoria',
                type: 'checkboxes',
                value: [],
                text: 'Kategoria materiału',
                firstOption: 'Wszystkie',
                noRefetch: true
            },
            subname: {
                additionalText: 'Rodzaj',
                type: 'checkboxes',
                value: [],
                options: [
                    {
                        value: 'obowiązkow',
                        label: 'Obowiązkowy'
                    },
                    {
                        value: 'nieobowiązkow',
                        label: 'Nieobowiązkowy'
                    },
                    {
                        value: 'drukowan',
                        label: 'Drukowany'
                    },
                    {
                        value: 'online',
                        label: 'Online'
                    }
                ],
                text: 'Rodzaj materiału',
                firstOption: 'Wszystkie',
                noRefetch: true
            }
        }
    },

    mutations: {
        SET_NEWSPAPER_MATERIALS(state, newspaperMaterials) {
            state.newspaperMaterials = newspaperMaterials
        },

        SET_NEWSPAPERMATERIALS_STATUS(state, status) {
            state.status = status
        },

        SET_NEWSPAPERMATERIALS_SORT(state, payload) {
            state.sort = payload
        },

        SET_NEWSPAPERMATERIALS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },

        RESET_NEWSPAPERMATERIALS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        }
    },

    actions: {
        async loadNewspaperMaterials({ state, commit, getters }, payload) {
            try {
                commit('SET_NEWSPAPERMATERIALS_STATUS', 'loading')

                const locationIds = state.filters.locationId.value
                const locations = getters.getAvailableUserLocations
                const networkformat = {}
                const networklocation = []

                if (locationIds.length > 0) {
                    locationIds.forEach(loc => {
                        const location = locations.find(el => el.id === loc)
                        if (location.network_name === 'INDEPENDENT') {
                            networklocation.push(location.id)
                        } else if (location.network_name) {
                            const networkformatValue =
                                networkformat[
                                    `networkformat[${location.network_name}]`
                                ] || []
                            Vue.set(
                                networkformat,
                                `networkformat[${location.network_name}]`,
                                networkformatValue.concat(location.categories)
                            )
                        }
                    })
                }

                let params = {
                    sort: state.sort.by,
                    direction: state.sort.direction,
                    name: state.filters.name.value || undefined
                }
                if (networkformat) {
                    for (const [key, value] of Object.entries(networkformat)) {
                        params = {
                            ...params,
                            [key]: Array.from(new Set(value)).toString()
                        }
                    }
                }
                if (networklocation.length) {
                    params = {
                        ...params,
                        'networklocation[INDEPENDENT]': networklocation.toString()
                    }
                }

                const res = await this.$api.get('newspaper_materials', {
                    params
                })

                if (!res.data?.data) {
                    throw new Error('No data')
                }

                commit('SET_NEWSPAPER_MATERIALS', res.data.data)
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_NEWSPAPERMATERIALS_STATUS', 'idle')
            }
        },

        setNewspaperMaterialsSort({ commit }, payload) {
            commit('SET_NEWSPAPERMATERIALS_SORT', payload)
        }
    },

    getters: {
        getNewspaperMaterials: state => state.newspaperMaterials,
        getNewspaperMaterialsFilters: state => state.filters,
        getNewspaperMaterialsStatus: state => state.status,
        getNewspaperMaterialsSortOptions: state => state.sortOptions,
        getNewspaperMaterialsSort: state => state.sort,
        getMerchantsFormats: (state, getters) => {
            const locations = getters.getAvailableUserLocations

            return getters.getAvailableMerchants.map(el => {
                const { name, fullAddress, location_id } = el
                const loc = locations.find(loc => loc.id === location_id)

                let label = `${name}, ${fullAddress}`

                if (loc && loc.categories) {
                    label += ` (${loc.categories.join(', ')})`
                }

                return {
                    label,
                    value: location_id
                }
            })
        },
        getNewspaperMaterialTypes: state =>
            state.filters.subname.options.map(el => el.label)
    }
}
